import { createSetting, useDialog } from '@shopex/finder'
import { MessageBox } from 'element-ui'
import { formatTimeStampToStr } from '@/utils/index'
import { updateTag, deleteTag} from '../api'

const commonAction = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '提交', key: 'save', type: 'primary', size: 'default' }
]

export const tableSetting = (vm) => createSetting({
  columns: [
    { name: '标签Id', key: 'tag_code' },
    { name: '标签类型', key: 'tag_type' },
    { name: '标签名称', key: 'tag_name' },
    { name: '描述', key: 'tag_desc' },
    { name: '等级', key: 'err_level_name' },
  ],
  actions: [
    {
      name: '编辑',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          useDialog(null, {
            title: `新增风险标签`,
            width: '50%',
            orgData: rows[0],
            component: () => import('../comps/createForm.vue'),
            actions: commonAction
          }).then(async (arg) => {
            if(arg) {
              console.log(arg, 'edit_arg')
              let params = {
                ...arg,
                id: rows[0].id
              }
              try {
                await updateTag(params)
                vm.$message.success('保存成功')
                vm.refresh()
              } catch (error) {
                console.log(error)
              }
            }
          })
        }
      }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          MessageBox.confirm('请确认是否删除当前数据？', '提示').then(async () => {
            const ids = [rows[0].id]
            await deleteTag({ ids })
            vm.$message.success('删除成功')
            vm.refresh()
          })
        }
      }
    },
  ]
})
